import { memo } from "react";
import { useTranslation } from "react-i18next";
import { BodyCopy } from "../../../components/BodyCopy";
import {
  AuraLayout,
  Button,
  Layout,
  PageTitle,
} from "lola-framework-ui-test";
import { ErrorAlertIcon as ErrorIcon } from "../../../assets/icons";
import { FlowHeroMark } from "../../../components/FlowHeroMark";
import { useStore } from "../../../store/globalState";
import { usePartnerStore } from "../../../store/usePartnerStore";
import { ScrollFadeIndicator } from "../../../components/ScrollFadeIndicator";

/**
 * Session Expired Page
 * Displays when a user's session has expired (link expired or not found).
 * Shows a button to return to the partner app if sessionExpiredRedirectUrl is configured.
 */
export const SessionExpiredPage = memo(() => {
  const { t } = useTranslation();
  const { theme } = useStore();
  const sessionExpiredRedirectUrl = usePartnerStore(
    (state) => state.sessionExpiredRedirectUrl
  );

  const colorConfig = theme.errorView;
  const { backgroundBtn, textColorBtn, title, bodyCopy, iconColors, backgroundIcon } =
    colorConfig;

  const handleReturnToApp = () => {
    if (sessionExpiredRedirectUrl) {
      window.location.href = sessionExpiredRedirectUrl;
    }
  };

  return (
    <AuraLayout colorConfig={colorConfig} className="flow-landing-page">
      <Layout.Content className="landing-section flow-hero-section">
        <ScrollFadeIndicator color={colorConfig.bodyCopy} />

        <section className="flow-hero">

          <FlowHeroMark backgroundIcon={backgroundIcon}>

            <ErrorIcon size={60} colors={iconColors} />

          </FlowHeroMark>
        <section className="landing-container">
          <PageTitle
            highlight={t("error.sessionExpired")}
            highlightColor={title}
            secudnary=""
            secudnaryColor={title}
          />
          <BodyCopy textColor={bodyCopy}>
            {t("error.sessionExpiredMessage")}
          </BodyCopy>
        </section>
        </section>
      </Layout.Content>
      {sessionExpiredRedirectUrl && (
        <Layout.Footer>
          <section className="footer-section">
            <Button
              size="large"
              background={backgroundBtn}
              color={textColorBtn}
              onClick={handleReturnToApp}
            >
              {t("error.returnToApp")}
            </Button>
          </section>
        </Layout.Footer>
      )}
    </AuraLayout>
  );
});
